import { useEffect, useState } from "react";
import { QUERY_CALENDAR_LIST } from "services/graphQL/queries";
import { useCIQQuery } from "./ciq-gql-hooks";

export const useGetProjectCalendarHolidaysAndWeekends = (
  projectId: string,
  gqlClientForProject: any
) => {
  const [calendarOffs, setCalendarOffs] = useState({
    holidays: [],
    weekends: []
  });

  const { data: calHolidayData, refetch } = useCIQQuery(QUERY_CALENDAR_LIST, {
    client: gqlClientForProject,
    variables: { projectId },
    skip: !gqlClientForProject
  });

  useEffect(() => {
    if (
      calHolidayData?.gantt_calendar &&
      calHolidayData?.gantt_calendar?.length > 0
    ) {
      const calendar = calHolidayData.gantt_calendar[0];
      const holidays = calendar?.calendar_holiday_lists || [];
      const weekends: any = [];
      calendar?.calendar_shift_mapping?.forEach((weekday: any) => {
        if (weekday?.deleted) {
          weekends.push(weekday?.work_day);
        }
      });

      setCalendarOffs({ holidays, weekends });
    }
  }, [calHolidayData]);

  return { calendarOffs, refetch };
};
